export default __webpack_public_path__ + "static/media/logo2.6507adf9.png";